import React from 'react';
import nds from '@nerdwallet/base-styles/classes';
import EditableBulletedList from '../editable-bulleted-list/editable-bulleted-list';

const TwoColList = (props) => {
  const updatedProps = {
    ...props,
    isModule: false, // Ensure this list gets non-container widths/margins.
  };

  // Wrap in a full-width div to ensure lists are left-aligned.
  return (
    <div className={nds('width-100', 'margin-bottom-4')}>
      <EditableBulletedList {...updatedProps} />
    </div>
  );
};

TwoColList.propTypes = EditableBulletedList.propTypes;

TwoColList.defaultProps = EditableBulletedList.defaultProps;

TwoColList.getEditingConfig = EditableBulletedList.getEditingConfig;

TwoColList.displayName = 'TwoColList';

export default TwoColList;
